<template>
  <MotorContinueQuote productType="motor" />
</template>

<script>
import MotorContinueQuote from "../../components/MotorContinueQuote.vue";

export default {
  components: {
    MotorContinueQuote
  },
  async mounted() {
    //console.log("c13");

  }
};
</script>
